<template>
  <div class="borrow">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('menu.borrower') }}
        </h3>
        <div class="pull-right box-tools d-sm-none d-md-block">
          <template v-if="can([Permissions.backend.client.filterColumnTable])">
            <router-link
              :to="{name: 'switch-table-column-client'}"
              class="btn btn-default btn-sm margin-right-5"
            >
              <i class="fa fa-columns" /> {{ $t('label.showOrHideColumns') }}
            </router-link>
          </template>
          <button
            class="btn btn-primary btn-sm margin-r-5"
            v-if="can([Permissions.backend.client.syncAllLoan])"
            @click="onSyncAllLoans"
          >
            {{ $t('string.syncAllLoans') }}
          </button>
          <router-link
            :to="{name: 'upload-loan-and-collection-officer'}"
            class="btn btn-success btn-sm margin-r-5"
            v-if="can([Permissions.backend.client.uploadLoanAndCollectionOfficer])"
          >
            {{ $t('string.upload_loan_and_collection_officer') }}
          </router-link>
          <template v-if="can([Permissions.backend.client.export])">
            <a
              :href="`${baseUrl}/export/approved`"
              class="btn btn-info btn-sm"
            >
              <i class="fa fa-file-excel-o" /> {{ $t('label.exportAsExcel') }}
            </a>
          </template>
        </div>
      </div>
      <div class="box-body">
        <div class="row">
          <div class="dataTables_row_up">
            <div class="col-xs-8 col-sm-6 margin-bottom">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-default"
                >
                  {{ $t('label.showOrHideColumns') }}
                </button>
                <button
                  type="button"
                  class="btn btn-default dropdown-toggle"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span class="caret" />
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <ul
                  class="dropdown-menu"
                  aria-labelledby="showColumnRow"
                >
                  <template v-for="(column, columnIndex) in columns">
                    <li
                      @click="toggleColumn(columnIndex)"
                      :key="columnIndex"
                    >
                      <a
                        href="javascript:void(0)"
                        :class="`${(!oTable || oTable.columns().visible()[columnIndex]) ? 'text-blue' : 'text-red'}`"
                      >
                        <i
                          :class="`fa fa-${(!oTable || oTable.columns().visible()[columnIndex]) ? 'eye' : 'eye-slash'}`"
                        />
                        {{ $t(column.titleKey) }}
                      </a>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
            <div class="col-xs-4 col-sm-6 margin-bottom d-md-none d-sm-block">
              <div class="pull-right box-tools">
                <a
                  :href="`${baseUrl}/export/pending`"
                  class="btn btn-info btn-sm"
                >
                  <i class="fa fa-file-excel-o" /> {{ $t('label.exportAsExcel') }}
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div>
              <table
                id="borrow-table"
                class="table table-hover table-striped table-bordered"
              >
                <tbody />
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <comment-modal
      :route-view-all-comments="{
        name: 'show-client',
        params: {
          borrow_id
        }
      }"
    />
    <assign-loan-officer-modal @refreshList="oTable.draw()" />
    <AssignCollectionOfficerModal @refreshList="() => {oTable.draw()}" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CommentModal from '@/views/comments/components/CommentModal'
import AssignLoanOfficerModal from '@/views/borrows/_components/AssignLoanOfficerModal'
import AssignCollectionOfficerModal from '@/views/borrows/_components/AssignCollectionOfficerModal'
import Permissions from '@/permissions'

export default {
  name: 'List',
  components: {
    AssignCollectionOfficerModal,
    AssignLoanOfficerModal,
    CommentModal
  },
  metaInfo () {
    return {
      title: this.$t('menu.borrower'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  computed: {
    ...mapState({
      borrow_id: state => state.comment.borrow_id
    }),
    columns () {
      if (this.filterColumns.length) {
        return this.filterColumns.map((filterColumn) => {
          const column = JSON.parse(filterColumn.option)
          this.$set(column, 'title', this.$t(column.titleKey))
          return column
        })
      }
      return []
    }
  },
  watch: {
    '$i18n.locale' () {
      if (this.oTable !== null) {
        this.oTable.destroy()
        this.oTable = this.dataTable()
        this.oTable.draw(true)
      }
    },
    'oTable' () {
      this.setButtonAction()
    }
  },
  data () {
    return {
      baseUrl: process.env.VUE_APP_API,
      oTable: null,
      filterColumns: [],
      Permissions
    }
  },
  methods: {
    toggleColumn (column) {
      column = this.oTable.column(column)
      column.visible(!column.visible())
    },
    onDeleteClient (borrow_id) {
      const self = this
      this.$swal({
        title: this.$t('string.areYouSure?'),
        text: this.$t('string.youWillNotBeRevert'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('string.yesIDeleteIt!'),
        cancelButtonText: this.$t('string.cancel')
      }).then((result) => {
        if (result.value) {
          this.$axios.post(process.env.VUE_APP_API + '/api/v4/backend/client/delete', { client_id: borrow_id })
            .then(() => {
              self.oTable.draw(true)
              self.$swal(
                this.$t('string.deleted'),
                this.$t('string.theRequestHaveBeenProceeded'),
                'success'
              )
            })
            .catch((error) => {
              this.onResponseError(error)
            })
        }
      })
    },
    onSyncLoans (borrow_id) {
      this.$isLoading(true)
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/loan/sync-loan-by-borrower', {
        borrow_id: borrow_id
      }).then((response) => {
        if (response.data.code === 1) {
          this.$toastr('success', this.$t('string.theRequestHaveBeenProcessed'), this.$t('string.success'))
        } else {
          this.$toastr('error', response.data.message, this.$t('string.error'))
        }
      }).catch((error) => {
        this.onResponseError(error)
      }).finally(() => {
        this.$isLoading(false)
      })
    },
    onSyncAllLoans () {
      this.$swal({
        title: this.$t('string.are_you_sure'),
        text: this.$t('string.it_will_sync_all_loans_form_the_loandisk'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('button.yes_i_am_sure'),
        cancelButtonText: this.$t('button.cancel')
      }).then((result) => {
        if (result.value) {
          this.$isLoading(true)
          this.$axios.post(process.env.VUE_APP_API + '/api/v1/loan/sync-all-loans')
            .then((response) => {
              if (response.data.code === 1) {
                const message = response.data.data
                this.$toastr('success', message['message_' + this.$i18n.locale], this.$t('string.success'))
              } else {
                this.$toastr('error', response.data.message, this.$t('string.error'))
              }
            })
            .catch((error) => {
              this.onResponseError(error)
            })
            .finally(() => {
              this.$isLoading(false)
            })
        }
      })
    },
    dataTable () {
      const self = this
      return $('#borrow-table').DataTable({
        stateSave: true,
        processing: true,
        serverSide: true,
        scrollX: true,
        scrollCollapse: true,
        pageLength: process.env.VUE_APP_PAGE_LENGTH,
        lengthMenu: this.$lengthMenu,
        ajax: {
          method: 'POST',
          url: process.env.VUE_APP_API + '/api/v1/client/datatable',
          data: (d) => {
            d.status = 'Approved'
            d.labelShow = self.$t('label.show')
            d.labelEdit = self.$t('label.edit')
            d.labelAddLoan = self.$t('label.addLoan')
            d.labelDelete = self.$t('label.delete')
            d.noPermission = self.$t('string.noPermission')
            d.assignLoanOfficerLabel = self.$t('string.assignLoanOfficer')
            d.assignCollectionOfficerLabel = self.$t('string.assign_collection_officer')
            d.commentLabel = self.$t('string.comment')
            d.na = self.$t('string.na')
          },
          error: (xhr) => {
            this.onAccessDenied(xhr)
          }
        },
        columns: self.columns,
        order: [
          [3, 'desc']
        ],
        language: {
          url: `/locale/${this.$i18n.locale}.json`
        }
      })
    },
    updateToLoandisk (id) {
      const self = this
      this.$swal({
        title: 'Are you sure?',
        text: 'You want to update client to Loandisk system.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, I am sure!'
      }).then((result) => {
        if (result.value) {
          this.$isLoading(true)
          this.$axios.post(process.env.VUE_APP_API + '/api/v1/borrows/update-to-loandisk', { id: id })
            .then((response) => {
              if (response.data.code === 1) {
                self.oTable.draw(true)
                self.$swal(
                  'Update to Loandisk',
                  'Uploaded',
                  'success'
                )
              } else {
                if (response.data.message.length > 0) {
                  const messages = response.data.message
                  let html = '<ul>'
                  messages.forEach((message) => {
                    html += '<li>' + message + '</li>'
                  })
                  html += '</ul>'
                  self.$toastr('warning', html, 'Loandisk Integration')
                } else {
                  self.$toastr('warning', response.data.message, 'Loandisk Integration')
                }
              }
            })
            .catch((error) => {
              this.onResponseError(error)
            })
            .finally(() => {
              this.$isLoading(false)
            })
        }
      })
    },
    setButtonAction () {
      this.clearEventHandlers([
        '.btn-delete',
        '.borrow-show',
        '.borrow-edit',
        '.borrow-new-loan',
        '.borrow-update-to-loandisk',
        '.borrow-sync-loans',
        '.borrow-change-id',
        '.btn-comment',
        '.btn-assign-loan-officer',
        '.btn-collection-loan-officer'
      ])
      const self = this
      $(document).on('click', '.borrow-change-id', function () {
        self.$router.push({
          name: 'change-borrower-id',
          params: {
            borrow_id: $(this).attr('data-borrow')
          }
        })
      })
      $(document).on('click', '.borrow-update-to-loandisk', function () {
        self.updateToLoandisk($(this).attr('data-borrow'))
      })
      $(document).on('click', '.borrow-sync-loans', function () {
        self.onSyncLoans($(this).attr('data-borrow'))
      })
      $(document).on('click', '.btn-delete', function (e) {
        e.preventDefault()
        self.onDeleteClient($(this).attr('data-borrow'))
      })
      $(document).on('click', '.borrow-show', function (e) {
        e.preventDefault()
        self.$router.push({
          name: 'show-client',
          params: {
            borrow_id: $(this).attr('data-borrow')
          }
        })
      })
      $(document).on('click', '.borrow-edit', function (e) {
        e.preventDefault()
        self.$router.push({
          name: 'edit-client',
          params: {
            borrow_id: $(this).attr('data-borrow')
          }
        })
      })
      $(document).on('click', '.borrow-new-loan', function (e) {
        e.preventDefault()
        const borrowerId = $(this).attr('data-borrow')
        self.newLoan(borrowerId)
      })

      // comment
      $(document).on('click', '.btn-comment', function () {
        self.$store.commit('comment/openCommentModal')
        self.$store.commit('comment/setBorrowId', $(this).attr('data-borrow'))
      })
      // assign loan officer
      $(document).on('click', '.btn-assign-loan-officer', function () {
        self.$store.commit('loanOfficerAssignment/toggleAssignLoanOfficerModal')
        self.$store.commit('loanOfficerAssignment/setBorrowId', $(this).attr('data-borrow'))
      })
      // assign collection officer
      $(document).on('click', '.btn-collection-loan-officer', function () {
        self.$store.dispatch('collectionOfficer/setBorrowId', $(this).attr('data-borrow'))
      })
    },
    newLoan (borrowerId) {
      const self = this
      this.$swal({
        title: 'Are you sure?',
        text: 'You need to add new loan for this client?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, I want it!'
      }).then((result) => {
        if (result.value) {
          self.$router.push({
            name: 'create-loan',
            params: {
              borrowerId: borrowerId
            }
          })
        }
      })
    },
    async getColumns () {
      if (localStorage.hasOwnProperty('client_columns')) {
        this.filterColumns = JSON.parse(localStorage.getItem('client_columns'))
        return 0
      }

      await this.$axios.post(process.env.VUE_APP_API + '/api/v4/backend/filter-table-column/get-option', {
        model_type: 'Client'
      }).then(({ data }) => {
        if (data.data) {
          this.filterColumns = data.data
          localStorage.setItem('client_columns', JSON.stringify(this.filterColumns))
        }
      })
    }
  },
  async mounted () {
    await this.getColumns().then(() => {
      this.oTable = this.dataTable()
    })
  },
  beforeDestroy () {
    this.oTable.clear()
    this.oTable.destroy()
  }
}
</script>

<style scoped>

</style>
